const { makeStyles } = require('@material-ui/core')

const initialquestionnaireStyles = makeStyles(theme => ({
   iconQuestionnarie: {
      background: '#F4F7FE',
      padding: '1rem',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '60%',
      height: '20px',
      width: '20px'
   },

   modalButtonsContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      // justifyContent: 'space-evenly',
      gap: '3rem',
      marginTop: '.7rem'
   },
   confirmModalContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1.6rem 3rem',
      gap: '1rem'
   },
   PageContainer: {
      flexDirection: 'column',
      height: '100%',
      padding: theme.spacing(1, 2, 0, 2)
   },
   paper: {
      // height: '200px',
      width: '100%',
      borderTop: '8px solid #3264DC',
      // padding: theme.spacing(3, 3, 1.5),

      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      // alignItems: 'center',
      // justifyContent: 'center',
      margin: 10
      // padding: '2rem 3rem'
   },
   paperQuestion: {
      width: '70%',
      // padding: theme.spacing(3, 3, 1.5),
      border: '1px solid #3264DC',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: 10,
      boxShadow: '6px 27px 41px -9px rgba(194,194,194,1)',
      transition: '2s'
   },
   containerInputsQuestion: {
      padding: '1.7rem 0',
      width: '80%',
      transition: '2s'
   },
   containerTitle: {
      display: 'flex',
      flexDirection: 'column',
      gap: '30px',
      width: '70%',
      alignItems: 'center'
   },
   formControl: {
      width: '100%',
      height: '30px',
      minWidth: 120,
      textAlign: 'initial',
      fontSize: '14px'
      // '&:not(:first-child)': {
      //     marginTop: '20px'
      // }
   },
   formControlSelect: {
      width: '100%',
      display: 'flex',
      minWidth: 120,
      gap: '12px',
      justifyContent: 'space-between',
      alignItems: 'center'
      // '&:not(:first-child)': {
      //     marginTop: '20px'
      // }
   },
   formControlQuestion: {
      width: '60%'
   },
   title: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#434969'
   },
   autocomplete: {
      width: '50%',
      padding: '0'
   },
   boxItemSelect: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      // borderRadius: '10px',
      fontSize: '13px',
      width: '100%',
      height: '100%',
      padding: '1rem',
      margin: '0'
      // '&:hover': {
      //     background: '#3264DC0F 0% 0% no-repeat',
      //     color: '#3264DC'
      // }
   },
   selectInput: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      justifyContent: 'space-between'
   },
   paperAutocuplete: {
      padding: '1rem',
      '& .MuiAutocomplete-listbox': {
         '& li': {
            margin: '5px 0',
            borderRadius: '10px',
            '&:hover': {
               background: '#3264DC0F 0% 0% no-repeat',
               color: '#3264DC'
            }
         }
      }
   },
   root: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontSize: '13px'
   },

   listGroupContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      margin: '1.5rem 0'
   },
   inputAnswer: {
      width: '100%'
   },
   boxinputAnswer: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px'
   },
   list: {
      padding: '10px',

      '& li': {
         margin: '5px 0',
         borderRadius: '5px',
         padding: '16px',
         '&:hover': {
            background: '#3264DC0F 0% 0% no-repeat',
            color: '#3264DC'
         }
      }
   },
   NumberTextAnswer: {
      paddingTop: '8px',
      marginEnd: '13px',
      color: '#949494'
   },
   AddQuestion: {
      fontSize: '40px',
      cursor: 'pointer',
      marginStart: '1rem'
      // boxShadow: '0px 6px 6px #00000029',
      // borderRadius: '50%',
   }
}))

export default initialquestionnaireStyles
